if (!customElements.get("product-bundle")) {
  class ProductBundle extends HTMLElement {
    constructor() {
      super();
      this.ELM_mainBundle = this.querySelector("[data-main-bundle]");
      this.ELM_errorMessage = this.querySelector("[data-error-message]");
      this.ELM_addBundleButton = this.querySelector("[data-add-bundle-button]");
      this.ELM_totalPrice = this.querySelector(".pd-product-bundle__total");
      this.totalPrice = 0;

      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      this.ELM_addBundleButton.addEventListener(
        "click",
        this.addBundleToCart.bind(this),
      );
      this.querySelectorAll("[data-product-variant-label]").forEach((elm) => {
        elm.addEventListener("click", this.handleVariantActiveState.bind(this));
      });
      this.querySelectorAll(
        "[data-main-bundle] .pd-product-bundle-item",
      ).forEach((item) => {
        const checkbox = item.querySelector("input[type=checkbox]");
        checkbox.addEventListener("change", (e) => {
          this.onCalculateBundlePrice(e, item);
          this.onSelectProductVariant(e, item);
          this.onToggleAddBundleToCartState();
        });
      });
      this.onTriggerOpenMobileBundle();
    }

    onTriggerOpenMobileBundle(e) {
      const ELM_triggerBtns = this.querySelectorAll(
        "[data-mobile-bundle-toggle]",
      );
      ELM_triggerBtns.forEach((ELM_triggerBtn) => {
        ELM_triggerBtn.addEventListener("click", () => {
          const isOpen = this.ELM_mainBundle.classList.contains("hide-mobile");
          if (isOpen) {
            document
              .getElementById("shopify-section-header")
              .classList.add("shopify-section-header-hidden");

            document.body.classList.add("overflow-hidden");
            document.querySelector("html").classList.add("overflow-hidden");

            this.ELM_mainBundle.classList.remove("hide-mobile");
            this.ELM_mainBundle.classList.add(
              "pd-product-bundle__desktop--floated",
            );
          } else {
            document.body.classList.remove("overflow-hidden");
            document.querySelector("html").classList.remove("overflow-hidden");

            this.ELM_mainBundle.classList.add("hide-mobile");
            this.ELM_mainBundle.classList.remove(
              "pd-product-bundle__desktop--floated",
            );
          }
        });
      });
    }

    onSelectProductVariant(e, parentElm) {
      const el = e.target;
      const checked = e.target.checked || false;
      el.toggleAttribute("checked", checked);
      el.checked = checked;

      const productVariantId = parentElm.id.split("ProductBundleItem-").pop();
      if (checked) {
        parentElm.classList.add("selected");
        parentElm
          .querySelector(`.product-card-wrapper`)
          .setAttribute("data-card-variant-id", productVariantId);
      } else {
        parentElm.classList.remove("selected");
        parentElm
          .querySelector(`.product-card-wrapper`)
          .removeAttribute("data-card-variant-id");
      }
    }

    onCalculateBundlePrice(e, parentElm) {
      const checked = e.target.checked || false;
      const productChecked = parentElm.querySelector(`.product-card-wrapper`);
      const products = this.querySelectorAll(
        `[data-main-bundle] .product-card-wrapper`,
      );

      products.forEach((product) => {
        const ELM_price =
          product?.querySelector(".price-item--sale") ||
          product?.querySelector(".price-item--regular");
        const price = ELM_price
          ? parseFloat(ELM_price.innerHTML.replace(/[^0-9.-]+/g, ""))
          : 0;

        if (product === productChecked && checked) {
          this.totalPrice += price;
        } else if (product === productChecked && !checked) {
          this.totalPrice -= price;
        }
      });

      const oldTotalPrice = parseFloat(
        this.ELM_totalPrice.innerHTML.replace(/[^0-9.-]+/g, ""),
      );
      this.ELM_totalPrice.innerHTML = this.ELM_totalPrice.innerHTML.replace(
        oldTotalPrice.toFixed(2),
        this.totalPrice.toFixed(2),
      );
    }

    onToggleAddBundleToCartState() {
      const hasSelectedCard = !!this.querySelector(
        ".product-card-wrapper[data-card-variant-id]",
      );
      this.ELM_addBundleButton.classList.toggle(
        "button--disabled",
        !hasSelectedCard,
      );
    }

    addBundleToCart(e) {
      e.preventDefault();
      const ELM_variants = this.querySelectorAll("[data-card-variant-id]");
      const items = [];
      const itemVariantIds = [];
      const buttonText = this.ELM_addBundleButton.innerHTML;

      ELM_variants.forEach((ELM_variant) => {
        items.push({
          id: ELM_variant.dataset.cardVariantId,
          quantity: 1,
        });

        itemVariantIds.push(ELM_variant.dataset.cardVariantId);
      });

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      this.ELM_addBundleButton.innerHTML = "Adding...";
      this.ELM_addBundleButton.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items,
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.id),
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.ELM_errorMessage.innerHTML = "Error: Out of stock!";
            this.ELM_addBundleButton.innerHTML = buttonText;
            return;
          }

          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true },
            );
            quickAddModal.hide(true);
          } else {
            let newItems = response.items.map((item) => ({
              ...item,
              sections: response.sections,
            }));
            this.cart.renderContents(newItems);
          }

          this.ELM_errorMessage.innerHTML = "";
          this.ELM_addBundleButton.innerHTML = "Added!";
          setTimeout(
            () => (this.ELM_addBundleButton.innerHTML = buttonText),
            2000,
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          this.ELM_addBundleButton.disabled = false;
        });
    }

    handleVariantActiveState(e) {
      const ELM_currentVariantLabel = e.currentTarget;
      const ELM_variantRadios =
        ELM_currentVariantLabel.closest("variant-radios");

      ELM_variantRadios.querySelectorAll(
        "[data-product-variant-label]",
      ).forEach((ELM_variantRadio) => {
        ELM_variantRadio.classList.remove("active");
      });

      ELM_currentVariantLabel.classList.add("active");
    }
  }

  customElements.define("product-bundle", ProductBundle);
}
